import '../../assets/css/loader.css';
import { RotatingLines, ThreeDots } from  'react-loader-spinner'

const ScreenLoading = () => {
  return (
    <div
        id={'full-screen-loader'}
        className='w-screen h-screen fixed bg-black bg-opacity-50 flex-col gap-3 items-center justify-center hidden'
    >
        <RotatingLines
            strokeColor="white"
            strokeWidth="3"
            animationDuration="0.75"
            width="60"
            visible={true}
        />
        <div className="flex items-end justify-around">
            <div id='loading-text' className="text-xl text-white mr-1" >
                Loading
            </div>
            <ThreeDots 
                height="17" 
                width="20" 
                radius="6"
                color="white" 
                ariaLabel="three-dots-loading"
                wrapperStyle={{}}
                visible={true}
            />
        </div>
    </div>
  );
};

export default ScreenLoading;
